@if (is_active && caption) {
  <div class="page-slider__header">
    {{caption}}
  </div>
}
@if (is_active) {
  <div class="help-slider__element">
    <ng-content></ng-content>
  </div>
}
